/*  eslint-disable react/jsx-max-depth */

import React, { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Divider,
  Input,
  Page,
  Card,
  Typography,
  Flex,
  Grid,
  Form,
} from "@samskip/frontend-components";
import { PageProps, navigate } from "gatsby";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DomesticConstants, NavigationConstants } from "@assets/constants";
import { DomesticFormTypes } from "@assets/formTypes";
import kioskTransportIllustration from "@assets/images/kiosk-transport.svg";
import samskipLogo from "@assets/images/samskip-logo.png";
import { getErrorMessage } from "@assets/utilities/translateUtilities";
import { DomesticYup } from "@assets/yupObjects";
import DomesticService from "@services/DomesticService";

const Kiosk = ({ location }: PageProps) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    formState: { errors },
    handleSubmit,
    register,
    setError,
  } = useForm({
    defaultValues: DomesticFormTypes.defaultDomesticKioskFormValues,
    resolver: yupResolver(DomesticYup.domesticKioskSchema),
    mode: "onTouched",
  });

  const onSubmit = async (data: DomesticFormTypes.DomesticKioskForm) => {
    setIsSubmitting(true);
    try {
      await DomesticService.getBookingLabelInfo(data.BookingNo);
      navigate(
        `${NavigationConstants.NAVIGATION_LINKS.domestic}/labels/${data.BookingNo}${location.search}`
      );
    } catch {
      setError("BookingNo", {
        type: "custom",
        message: DomesticConstants.ERROR_LABELS.BOOKING_NOT_FOUND,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Page size="medium">
      <Form id="domestic_kiosk_form">
        <Flex alignItems="center" gap="medium" justifyContent="center" vertical>
          <img alt="SAMSKIP" className="w-1/4" src={samskipLogo} />
          <Divider />
          <img
            alt="CAR"
            className="max-w-full h-auto"
            src={kioskTransportIllustration}
          />
          <Grid className="w-full" mdCol={2}>
            <Grid.Item>
              <Card bordered>
                <Flex gap="small" vertical>
                  <Flex gap="medium" inline>
                    <Input
                      disabled={isSubmitting}
                      errorMessage={getErrorMessage("BookingNo", errors)}
                      hasError={errors["BookingNo"] != null}
                      id="bookingInput"
                      placeholder={t("PLACEHOLDER_BOOKINGNO")}
                      {...register("BookingNo")}
                      maxLength={
                        DomesticConstants.DOMESTIC_KIOSK_INPUT_CONSTRAINTS
                          .MAX_BOOKING_NO_LENGHT
                      }
                      required
                    />
                    <Button
                      className="col-span-2"
                      form="domestic_kiosk_form"
                      loading={isSubmitting}
                      onClick={handleSubmit(onSubmit)}
                    >
                      {t("LABEL_PRINTBARCODES")}
                    </Button>
                  </Flex>
                  <Typography>{t("TEXT_PRINT_BARCODES")}</Typography>
                </Flex>
              </Card>
            </Grid.Item>
            <Grid.Item>
              <Card bordered>
                <Flex gap="small" vertical>
                  <Button
                    onClick={() =>
                      navigate(
                        `${NavigationConstants.NAVIGATION_LINKS.domestic}/create/kiosk${location.search}`
                      )
                    }
                    variant="secondary"
                  >
                    {t("LABEL_CREATE_BOOKING")}
                  </Button>
                  <Typography>{t("TEXT_CREATE_BOOKING")}</Typography>
                </Flex>
              </Card>
            </Grid.Item>
          </Grid>
        </Flex>
      </Form>
    </Page>
  );
};

export default Kiosk;
